exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".calculator{background-color:#f2f3f4;border-radius:5px}.calculator-icon{font-size:35px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/pricing/add-item-modal/calculator.scss
// module id = 5845
// module chunks = 0